/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-search
 * Fiona Search Service
 *
 * The version of the OpenAPI document: 0.2.171
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DebtConsolidationCalcResult,
} from '../models';

export interface DebtConsolidationControllerGetDebtConsolidationCalculationResultRequest {
    currentDebt: number;
    currentMonthlyPayment: number;
    currentApr: number;
    creditScore: DebtConsolidationControllerGetDebtConsolidationCalculationResultCreditScoreEnum;
    zipcode: string;
    loanPurpose?: DebtConsolidationControllerGetDebtConsolidationCalculationResultLoanPurposeEnum;
}

/**
 * DebtConsolidationControllerApi - interface
 * 
 * @export
 * @interface DebtConsolidationControllerApiInterface
 */
export interface DebtConsolidationControllerApiInterface {
    /**
     * 
     * @param {number} currentDebt 
     * @param {number} currentMonthlyPayment 
     * @param {number} currentApr 
     * @param {'excellent' | 'good' | 'fair' | 'poor'} creditScore 
     * @param {string} zipcode 
     * @param {'debt_consolidation' | 'credit_card_refi' | 'home_improvement' | 'large_purchases' | 'auto_purchase' | 'auto_refinance' | 'baby' | 'boat' | 'business' | 'car_repair' | 'cosmetic' | 'emergency' | 'engagement' | 'green' | 'home_purchase' | 'home_refi' | 'household_expenses' | 'life_event' | 'medical_dental' | 'motorcycle' | 'moving_relocation' | 'rv' | 'special_occasion' | 'student_loan' | 'student_loan_refi' | 'taxes' | 'vacation' | 'wedding' | 'other'} [loanPurpose] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DebtConsolidationControllerApiInterface
     */
    debtConsolidationControllerGetDebtConsolidationCalculationResultRaw(requestParameters: DebtConsolidationControllerGetDebtConsolidationCalculationResultRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DebtConsolidationCalcResult>>;

    /**
     */
    debtConsolidationControllerGetDebtConsolidationCalculationResult(requestParameters: DebtConsolidationControllerGetDebtConsolidationCalculationResultRequest, initOverrides?: RequestInit): Promise<DebtConsolidationCalcResult>;

}

/**
 * 
 */
export class DebtConsolidationControllerApi extends runtime.BaseAPI implements DebtConsolidationControllerApiInterface {

    /**
     */
    async debtConsolidationControllerGetDebtConsolidationCalculationResultRaw(requestParameters: DebtConsolidationControllerGetDebtConsolidationCalculationResultRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<DebtConsolidationCalcResult>> {
        if (requestParameters.currentDebt === null || requestParameters.currentDebt === undefined) {
            throw new runtime.RequiredError('currentDebt','Required parameter requestParameters.currentDebt was null or undefined when calling debtConsolidationControllerGetDebtConsolidationCalculationResult.');
        }

        if (requestParameters.currentMonthlyPayment === null || requestParameters.currentMonthlyPayment === undefined) {
            throw new runtime.RequiredError('currentMonthlyPayment','Required parameter requestParameters.currentMonthlyPayment was null or undefined when calling debtConsolidationControllerGetDebtConsolidationCalculationResult.');
        }

        if (requestParameters.currentApr === null || requestParameters.currentApr === undefined) {
            throw new runtime.RequiredError('currentApr','Required parameter requestParameters.currentApr was null or undefined when calling debtConsolidationControllerGetDebtConsolidationCalculationResult.');
        }

        if (requestParameters.creditScore === null || requestParameters.creditScore === undefined) {
            throw new runtime.RequiredError('creditScore','Required parameter requestParameters.creditScore was null or undefined when calling debtConsolidationControllerGetDebtConsolidationCalculationResult.');
        }

        if (requestParameters.zipcode === null || requestParameters.zipcode === undefined) {
            throw new runtime.RequiredError('zipcode','Required parameter requestParameters.zipcode was null or undefined when calling debtConsolidationControllerGetDebtConsolidationCalculationResult.');
        }

        const queryParameters: any = {};

        if (requestParameters.currentDebt !== undefined) {
            queryParameters['currentDebt'] = requestParameters.currentDebt;
        }

        if (requestParameters.currentMonthlyPayment !== undefined) {
            queryParameters['currentMonthlyPayment'] = requestParameters.currentMonthlyPayment;
        }

        if (requestParameters.currentApr !== undefined) {
            queryParameters['currentApr'] = requestParameters.currentApr;
        }

        if (requestParameters.creditScore !== undefined) {
            queryParameters['creditScore'] = requestParameters.creditScore;
        }

        if (requestParameters.zipcode !== undefined) {
            queryParameters['zipcode'] = requestParameters.zipcode;
        }

        if (requestParameters.loanPurpose !== undefined) {
            queryParameters['loanPurpose'] = requestParameters.loanPurpose;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/calculators/debt-consolidation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async debtConsolidationControllerGetDebtConsolidationCalculationResult(requestParameters: DebtConsolidationControllerGetDebtConsolidationCalculationResultRequest, initOverrides?: RequestInit): Promise<DebtConsolidationCalcResult> {
        const response = await this.debtConsolidationControllerGetDebtConsolidationCalculationResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export type DebtConsolidationControllerGetDebtConsolidationCalculationResultCreditScoreEnum = 'excellent' |'good' |'fair' |'poor' 
/**
    * @export
    * @enum {string}
    */
export type DebtConsolidationControllerGetDebtConsolidationCalculationResultLoanPurposeEnum = 'debt_consolidation' |'credit_card_refi' |'home_improvement' |'large_purchases' |'auto_purchase' |'auto_refinance' |'baby' |'boat' |'business' |'car_repair' |'cosmetic' |'emergency' |'engagement' |'green' |'home_purchase' |'home_refi' |'household_expenses' |'life_event' |'medical_dental' |'motorcycle' |'moving_relocation' |'rv' |'special_occasion' |'student_loan' |'student_loan_refi' |'taxes' |'vacation' |'wedding' |'other' 
